
// import React, { useEffect, useMemo, useState } from "react";
// import api from "../chat/api";
// import { toast } from "react-hot-toast";
// import { PlusIcon, MinusIcon } from "./ScoringConfigurationSvgs";
// import { IndustryIcons } from "./IndustryIcons"; // <— NEW IMPORT


// const AddScoringAspectModal = ({ open, onClose, onAdd, orgId }) => {
//   const [tab, setTab] = useState("custom"); // "custom" | "presets"
//   const [name, setName] = useState("");
//   const [description, setDescription] = useState("");
//   const [weightage, setWeightage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);


//   // Presets state
//   const [presets, setPresets] = useState([]);
//   const [selectedPresetKey, setSelectedPresetKey] = useState(null);
//   const [loadingPresets, setLoadingPresets] = useState(false);


//   const canSubmit = useMemo(() => {
//     if (tab === "presets") return !!selectedPresetKey;
//     return name.trim().length > 0 && description.trim().length > 0;
//   }, [tab, name, description, selectedPresetKey]);


//   useEffect(() => {
//     if (!open) return;


//     const onKeyDown = (e) => {
//       if (e.key === "Escape") onClose?.();
//     };


//     window.addEventListener("keydown", onKeyDown);
//     return () => window.removeEventListener("keydown", onKeyDown);
//   }, [open, onClose]);


//   useEffect(() => {
//     if (!open) return;
//     setTab("custom");
//     setName("");
//     setDescription("");
//     setWeightage(1);
//     setLoading(false);
//     setSuccess(false);
//     setPresets([]);
//     setSelectedPresetKey(null);
//   }, [open]);


//   // Fetch presets when tab changes to "presets"
//   useEffect(() => {
//     if (tab === "presets" && open && presets.length === 0) {
//       fetchPresets();
//     }
//   }, [tab, open]); // eslint-disable-line react-hooks/exhaustive-deps


//   const fetchPresets = async () => {
//     setLoadingPresets(true);
//     try {
//       const response = await api.get(
//         `/api/v1/org/scoring/presets/?organization_id=${orgId}`
//       );
//       if (response.data) {
//         setPresets(response.data.presets || []);
//         if (response.data.selected_preset) {
//           setSelectedPresetKey(response.data.selected_preset);
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching presets:", error);
//       toast.error("Failed to load presets");
//     } finally {
//       setLoadingPresets(false);
//     }
//   };


//   if (!open) return null;


//   const dec = () => setWeightage((w) => Math.max(1, w - 1));
//   const inc = () => setWeightage((w) => Math.min(10, w + 1));


//   const handleBackdropClick = (e) => {
//     if (e.target === e.currentTarget && !loading) onClose?.();
//   };


//   const handleApplyPreset = async () => {
//     if (!selectedPresetKey || loading || success) return;
//     setLoading(true);


//     try {
//       await api.post(`/api/v1/org/scoring/presets/select/`, {
//         organization_id: parseInt(orgId),
//         preset: selectedPresetKey,
//       });


//       setLoading(false);
//       setSuccess(true);


//       setTimeout(() => {
//         onClose?.();
//         onAdd?.();
//         setSuccess(false);
//       }, 2000);
//     } catch (error) {
//       console.error("Error applying preset:", error);
//       toast.error("Failed to apply preset");
//       setLoading(false);
//     }
//   };


//   const handleSubmit = async () => {
//     if (tab === "presets") {
//       handleApplyPreset();
//       return;
//     }


//     if (!canSubmit || loading || success) return;


//     setLoading(true);


//     try {
//       await api.post("/api/v1/org/scoring/aspects/", {
//         organization_id: parseInt(orgId),
//         name: name.trim(),
//         weightage: weightage,
//         description: description.trim(),
//       });


//       setLoading(false);
//       setSuccess(true);


//       setTimeout(() => {
//         onClose?.();
//         onAdd?.();
//         setSuccess(false);
//       }, 2000);
//     } catch (error) {
//       console.error("Error adding aspect:", error);
//       toast.error("Failed to add aspect");
//       setLoading(false);
//     }
//   };


//   return (
//     <div
//       onMouseDown={handleBackdropClick}
//       className="fixed inset-0 z-[999] flex items-center justify-center bg-black/30 px-4"
//     >
//       <div className="w-full max-w-[850px] rounded-[16px] bg-white shadow-[0px_20px_60px_rgba(0,0,0,0.15)] flex flex-col max-h-[90vh]">
//         {/* Header */}
//         <div className="flex items-start justify-between px-6 pt-4 pb-3 flex-shrink-0">
//           <div>
//             <h3 className="text-[18px] font-semibold text-[#3F3F46] font-outfit">
//               Add Scoring Aspect
//             </h3>
//             <p className="text-[14px] text-[#52525B] font-normal font-outfit mt-1">
//               Create a custom aspect or apply an industry preset configuration.
//             </p>
//           </div>


//           <button
//             onClick={onClose}
//             disabled={loading}
//             className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center text-[#18181B] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//             aria-label="Close modal"
//             type="button"
//           >
//             <svg
//               width="20"
//               height="20"
//               viewBox="0 0 20 20"
//               fill="none"
//               xmlns="http://www.w3.org/2000/svg"
//             >
//               <path
//                 d="M15 5L5 15M5 5L15 15"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//         </div>


//         {/* Tabs */}
//         <div className="px-6  flex-shrink-0">
//           <div className="w-full rounded-[10px] border border-[#CCCCCC] border-[0.5px] bg-[#FAFAFA] p-1 flex gap-1">
//             <button
//               type="button"
//               onClick={() => setTab("custom")}
//               disabled={loading}
//               className={`flex-1 h-[40px] rounded-[8px] text-[15px] font-medium font-outfit transition-all ${
//                 tab === "custom"
//                   ? "bg-[#C95EBE] text-white shadow-sm"
//                   : "text-[#52525B] hover:bg-white/50"
//               }`}
//             >
//               Custom Aspect
//             </button>
//             <button
//               type="button"
//               onClick={() => setTab("presets")}
//               disabled={loading}
//               className={`flex-1 h-[40px] rounded-[8px] text-[15px] font-medium font-outfit transition-all ${
//                 tab === "presets"
//                   ? "bg-[#C95EBE] text-white shadow-sm"
//                   : "text-[#52525B] hover:bg-white/50"
//               }`}
//             >
//               Presets
//             </button>
//           </div>
//         </div>


//         {/* Body - Main Content Area */}
//         <div className="px-6 pt-5 pb-2 flex-1 min-h-0 flex flex-col">
//           {tab === "custom" ? (
//             <div className="rounded-[12px] border border-[#CCCCCC] border-[0.5px] bg-white p-5 h-[calc(100vh-500px)]">
//               <div className="grid grid-cols-1 md:grid-cols-[1fr_140px] gap-5">
//                 {/* Aspect Name */}
//                 <div>
//                   <label className="block text-[14px] font-medium text-[#18181B] font-outfit mb-1">
//                     Aspect Name<span className="text-[#EF4444]">*</span>
//                   </label>
//                   <input
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     disabled={loading || success}
//                     placeholder="e.g. Safety Certifications"
//                     className="w-full h-[40px] rounded-[8px] border border-[#CCCCCC] border-[0.5px] px-4 text-[14px] hover:text-[14px] font-outfit text-[#18181B] placeholder:text-[#A1A1AA] bg-white outline-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] disabled:bg-gray-50"
//                   />
//                 </div>


//                 {/* Weightage */}
//                 <div>
//                   <div className="flex items-center justify-between ">
//                     <label className="block text-[14px] font-medium text-[#18181B] font-outfit">
//                       Weightage
//                     </label>
//                     <button
//                       type="button"
//                       className="w-4 h-4 rounded-full border border-[#D4D4D8] bg-white text-[#71717A] text-[12px] font-medium flex items-center justify-center hover:bg-gray-50 transition-colors"
//                       aria-label="Weightage help"
//                       title="Choose a weight from 1 to 10"
//                     >
//                       <span className="ml-[1px]">?</span>
//                     </button>
//                   </div>


//                   <div className="h-[40px] rounded-[8px] border border-[#CCCCCC] border-[0.5px] bg-white px-3 flex items-center justify-between">
//                     <button
//                       type="button"
//                       onClick={dec}
//                       disabled={weightage <= 1 || loading || success}
//                       className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
//                     >
//                       <MinusIcon className="w-4 h-4 text-[#52525B]" />
//                     </button>


//                     <div className="text-[15px] font-medium text-[#18181B] font-outfit">
//                       {String(weightage).padStart(2, "0")}
//                     </div>


//                     <button
//                       type="button"
//                       onClick={inc}
//                       disabled={weightage >= 10 || loading || success}
//                       className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
//                     >
//                       <PlusIcon className="w-4 h-4 text-[#52525B]" />
//                     </button>
//                   </div>
//                 </div>
//               </div>


//               {/* Description */}
//               <div className="mt-2">
//                 <label className="block text-[14px] font-medium text-[#18181B] font-outfit mb-2">
//                   Description<span className="text-[#EF4444]">*</span>
//                 </label>
//                 <textarea
//                   value={description}
//                   onChange={(e) => setDescription(e.target.value)}
//                   disabled={loading || success}
//                   placeholder="What will this aspect evaluate?"
//                   className="w-full h-[calc(100vh-640px)] rounded-[8px] border border-[#CCCCCC] border-[0.5px] px-4 py-2 text-[14px] font-outfit text-[#18181B] placeholder:text-[#A1A1AA] bg-white outline-none resize-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] disabled:bg-gray-50"
//                 />
//               </div>
//             </div>
//           ) : (
//             // PRESETS TAB UI
//             <div className="flex flex-col">
//               {/* Scrollable List Container with FIXED HEIGHT */}
//               <div className="h-[calc(100vh-510px)] overflow-y-auto border custom-scrollbar px-4 py-3 rounded-[8px] space-y-3">
//                 {loadingPresets ? (
//                   <div className="h-full flex flex-col items-center justify-center">
//                     <div className="w-8 h-8 border-2 border-[#CCCCCC] border-[0.5px] border-t-[#C95EBE] rounded-full animate-spin mb-2"></div>
//                     <span className="text-sm text-gray-500 font-outfit">
//                       Loading presets...
//                     </span>
//                   </div>
//                 ) : (
//                   presets.map((preset) => (
//                     <div
//                       key={preset.key}
//                       onClick={() => setSelectedPresetKey(preset.key)}
//                       className={`rounded-[10px] border px-3 py-2 cursor-pointer transition-all ${
//                         selectedPresetKey === preset.key
//                           ? "border-[#C95EBE] bg-[#FDF4FF]"
//                           : "border-[#CCCCCC] border-[0.5px] bg-white hover:border-[#C95EBE]/70"
//                       }`}
//                     >
//                       <div className="flex items-center gap-3 mb-2">
//                         <div
//                           className={`w-7 h-7 rounded-full flex items-center justify-center ${
//                             selectedPresetKey === preset.key
//                               ? "bg-[#C95EBE]/10"
//                               : "bg-[#F4F4F5]"
//                           }`}
//                         >
//                           {IndustryIcons[preset.key] || IndustryIcons.default}
//                         </div>
//                         <h4 className="text-[15px] font-medium text-[#18181B] font-outfit">
//                           {preset.name}
//                         </h4>
//                       </div>


//                       <div className="flex flex-wrap gap-2">
//                         {preset.aspects.map((aspect, idx) => (
//                           <div
//                             key={idx}
//                             className={`px-3 py-1 rounded-full text-[12px] font-normal font-outfit border ${
//                               selectedPresetKey === preset.key
//                                 ? "bg-white border-[#C95EBE]/20 text-[#3F3F46]"
//                                 : "bg-[#F5F5F5] border-[#CCCCCC] text-[#3F3F46]"
//                             }`}
//                           >
//                             {aspect.name} ({aspect.weightage}/10)
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>
//             </div>
//           )}
//         </div>


//         {/* Footer Buttons + Warning - Fixed at bottom */}
//         <div className="px-6 pb-4 mt-2 flex items-center justify-between gap-3 flex-shrink-0 bg-white rounded-b-[16px]">
//           {/* Left side: warning only for presets */}
//           {tab === "presets" ? (
//             <div className="flex items-center gap-2 text-[#71717A]">
//               <svg
//                 width="16"
//                 height="16"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               >
//                 <circle cx="12" cy="12" r="10"></circle>
//                 <line x1="12" y1="8" x2="12" y2="12"></line>
//                 <line x1="12" y1="16" x2="12.01" y2="16"></line>
//               </svg>
//               <span className="text-[13px] font-outfit">
//                 Applying a preset will replace your current configuration.
//               </span>
//             </div>
//           ) : (
//             <div /> // empty spacer so buttons stay on the right for custom tab
//           )}


//           {/* Right side: buttons (always right aligned) */}
//           <div className="flex items-center gap-3">
//             <button
//               type="button"
//               onClick={onClose}
//               disabled={loading || success}
//               className="h-[42px] px-6 rounded-[8px] border border-[#CCCCCC] border-[0.5px] bg-white text-[14px] font-medium text-[#18181B] font-outfit hover:bg-gray-50 transition-colors disabled:opacity-50"
//             >
//               Cancel
//             </button>


//             <button
//               type="button"
//               onClick={handleSubmit}
//               disabled={!canSubmit || loading || success}
//               className={`h-[42px] px-6 rounded-[8px] text-[14px] font-medium font-outfit transition-all disabled:opacity-50 disabled:cursor-not-allowed text-white shadow-sm flex items-center gap-2 ${
//                 success ? "bg-[#2DAD4E]" : "bg-[#C95EBE] hover:bg-[#A3398D]"
//               }`}
//             >
//               {loading ? (
//                 <>
//                   <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//                   <span>{"Adding..."}</span>
//                 </>
//               ) : success ? (
//                 <>
//                   <svg
//                     width="16"
//                     height="16"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="3"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   >
//                     <polyline points="20 6 9 17 4 12"></polyline>
//                   </svg>
//                   <span>{"Added"}</span>
//                 </>
//               ) : (
//                 "Add Aspect"
//               )}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };


// export default AddScoringAspectModal;
import React, { useEffect, useMemo, useState } from "react";
import api from "../chat/api";
import { toast } from "react-hot-toast";
import { PlusIcon, MinusIcon } from "./ScoringConfigurationSvgs";
import { IndustryIcons } from "./IndustryIcons"; // <— NEW IMPORT

const AddScoringAspectModal = ({
  open,
  onClose,
  onAdd,
  orgId,
  initialTab = "custom",
}) => {
  const [tab, setTab] = useState(initialTab); // "custom" | "presets"
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [weightage, setWeightage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  // Presets state
  const [presets, setPresets] = useState([]);
  const [selectedPresetKey, setSelectedPresetKey] = useState(null);
  const [initialPresetKey, setInitialPresetKey] = useState(null);
  const [loadingPresets, setLoadingPresets] = useState(false);

  const canSubmit = useMemo(() => {
    if (tab === "presets")
      return !!selectedPresetKey && selectedPresetKey !== initialPresetKey;
    return name.trim().length > 0 && description.trim().length > 0;
  }, [tab, name, description, selectedPresetKey, initialPresetKey]);

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  useEffect(() => {
    if (!open) return;
    setTab(initialTab);
    setName("");
    setDescription("");
    setWeightage(1);
    setLoading(false);
    setSuccess(false);
    setPresets([]);
    setSelectedPresetKey(null);
    setInitialPresetKey(null);
  }, [open, initialTab]);

  // Fetch presets when tab changes to "presets"
  useEffect(() => {
    if (tab === "presets" && open && presets.length === 0) {
      fetchPresets();
    }
  }, [tab, open, presets.length, orgId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchPresets = async () => {
    setLoadingPresets(true);
    try {
      const response = await api.get(
        `/api/v1/org/scoring/presets/?organization_id=${orgId}`
      );
      if (response.data) {
        setPresets(response.data.presets || []);
        if (response.data.selected_preset) {
          setSelectedPresetKey(response.data.selected_preset);
          setInitialPresetKey(response.data.selected_preset);
        }
      }
    } catch (error) {
      console.error("Error fetching presets:", error);
      toast.error("Failed to load presets");
    } finally {
      setLoadingPresets(false);
    }
  };

  if (!open) return null;

  const dec = () => setWeightage((w) => Math.max(1, w - 1));
  const inc = () => setWeightage((w) => Math.min(10, w + 1));

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !loading) onClose?.();
  };

  const handleApplyPreset = async () => {
    if (!selectedPresetKey || loading || success) return;
    setLoading(true);

    try {
      await api.post(`/api/v1/org/scoring/presets/select/`, {
        organization_id: parseInt(orgId),
        preset: selectedPresetKey,
      });

      setLoading(false);
      setSuccess(true);

      setTimeout(() => {
        onClose?.();
        onAdd?.();
        setSuccess(false);
      }, 2000);
    } catch (error) {
      console.error("Error applying preset:", error);
      toast.error("Failed to apply preset");
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (tab === "presets") {
      handleApplyPreset();
      return;
    }

    if (!canSubmit || loading || success) return;

    setLoading(true);

    try {
      await api.post("/api/v1/org/scoring/aspects/", {
        organization_id: parseInt(orgId),
        name: name.trim(),
        weightage: weightage,
        description: description.trim(),
      });

      setLoading(false);
      setSuccess(true);

      setTimeout(() => {
        onClose?.();
        onAdd?.();
        setSuccess(false);
      }, 2000);
    } catch (error) {
      console.error("Error adding aspect:", error);
      toast.error("Failed to add aspect");
      setLoading(false);
    }
  };

  return (
    <div
      onMouseDown={handleBackdropClick}
      className="fixed inset-0 z-[999] flex items-center justify-center bg-black/30 px-4"
    >
      <div className="w-full max-w-[850px] rounded-[16px] bg-white shadow-[0px_20px_60px_rgba(0,0,0,0.15)] flex flex-col max-h-[90vh]">
        {/* Header */}
        <div className="flex items-start justify-between px-6 pt-4 pb-3 flex-shrink-0">
          <div>
            <h3 className="text-[18px] font-semibold text-[#3F3F46] font-outfit">
              Add Scoring Aspect
            </h3>
            <p className="text-[14px] text-[#52525B] font-normal font-outfit mt-1">
              Create a custom aspect or apply an industry preset configuration.
            </p>
          </div>

          <button
            onClick={onClose}
            disabled={loading}
            className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center text-[#18181B] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            aria-label="Close modal"
            type="button"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Tabs */}
        <div className="px-6  flex-shrink-0">
          <div className="w-full rounded-[10px] border border-[#CCCCCC] border-[0.5px] bg-[#FAFAFA] p-1 flex gap-1">
            <button
              type="button"
              onClick={() => setTab("custom")}
              disabled={loading}
              className={`flex-1 h-[40px] rounded-[8px] text-[15px] font-medium font-outfit transition-all ${
                tab === "custom"
                  ? "bg-[#C95EBE] text-white shadow-sm"
                  : "text-[#52525B] hover:bg-white/50"
              }`}
            >
              Custom Aspect
            </button>
            <button
              type="button"
              onClick={() => setTab("presets")}
              disabled={loading}
              className={`flex-1 h-[40px] rounded-[8px] text-[15px] font-medium font-outfit transition-all ${
                tab === "presets"
                  ? "bg-[#C95EBE] text-white shadow-sm"
                  : "text-[#52525B] hover:bg-white/50"
              }`}
            >
              Presets
            </button>
          </div>
        </div>

        {/* Body - Main Content Area */}
        <div className="px-6 pt-5 pb-2 flex-1 min-h-0 flex flex-col">
          {tab === "custom" ? (
            <div className="rounded-[12px] border border-[#CCCCCC] border-[0.5px] bg-white p-5 h-[calc(100vh-500px)]">
              <div className="grid grid-cols-1 md:grid-cols-[1fr_140px] gap-5">
                {/* Aspect Name */}
                <div>
                  <label className="block text-[14px] font-medium text-[#18181B] font-outfit mb-1">
                    Aspect Name<span className="text-[#EF4444]">*</span>
                  </label>
                  <input
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={loading || success}
                    placeholder="e.g. Safety Certifications"
                    className="w-full h-[40px] rounded-[8px] border border-[#CCCCCC] border-[0.5px] px-4 text-[14px] hover:text-[14px] font-outfit text-[#18181B] placeholder:text-[#A1A1AA] bg-white outline-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] disabled:bg-gray-50"
                  />
                </div>

                {/* Weightage */}
                <div>
                  <div className="flex items-center justify-between ">
                    <label className="block text-[14px] font-medium text-[#18181B] font-outfit">
                      Weightage
                    </label>
                    <button
                      type="button"
                      className="w-4 h-4 rounded-full border border-[#D4D4D8] bg-white text-[#71717A] text-[12px] font-medium flex items-center justify-center hover:bg-gray-50 transition-colors"
                      aria-label="Weightage help"
                      title="Choose a weight from 1 to 10"
                    >
                      <span className="ml-[1px]">?</span>
                    </button>
                  </div>

                  <div className="h-[40px] rounded-[8px] border border-[#CCCCCC] border-[0.5px] bg-white px-3 flex items-center justify-between">
                    <button
                      type="button"
                      onClick={dec}
                      disabled={weightage <= 1 || loading || success}
                      className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      <MinusIcon className="w-4 h-4 text-[#52525B]" />
                    </button>

                    <div className="text-[15px] font-medium text-[#18181B] font-outfit">
                      {String(weightage).padStart(2, "0")}
                    </div>

                    <button
                      type="button"
                      onClick={inc}
                      disabled={weightage >= 10 || loading || success}
                      className="w-7 h-7 flex items-center justify-center rounded-md hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
                    >
                      <PlusIcon className="w-4 h-4 text-[#52525B]" />
                    </button>
                  </div>
                </div>
              </div>

              {/* Description */}
              <div className="mt-2">
                <label className="block text-[14px] font-medium text-[#18181B] font-outfit mb-2">
                  Description<span className="text-[#EF4444]">*</span>
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={loading || success}
                  placeholder="What will this aspect evaluate?"
                  className="w-full h-[calc(100vh-640px)] rounded-[8px] border border-[#CCCCCC] border-[0.5px] px-4 py-2 text-[14px] font-outfit text-[#18181B] placeholder:text-[#A1A1AA] bg-white outline-none resize-none focus:ring-2 focus:ring-[#C95EBE]/20 focus:border-[#C95EBE] disabled:bg-gray-50"
                />
              </div>
            </div>
          ) : (
            // PRESETS TAB UI
            <div className="flex flex-col">
              {/* Scrollable List Container with FIXED HEIGHT */}
              <div className="h-[calc(100vh-510px)] overflow-y-auto border custom-scrollbar px-4 py-3 rounded-[8px] space-y-3">
                {loadingPresets ? (
                  <div className="h-full flex flex-col items-center justify-center">
                    <div className="w-8 h-8 border-2 border-[#CCCCCC] border-[0.5px] border-t-[#C95EBE] rounded-full animate-spin mb-2"></div>
                    <span className="text-sm text-gray-500 font-outfit">
                      Loading presets...
                    </span>
                  </div>
                ) : (
                  presets.map((preset) => (
                    <div
                      key={preset.key}
                      onClick={() => setSelectedPresetKey(preset.key)}
                      className={`rounded-[10px] border px-3 py-2 cursor-pointer transition-all ${
                        selectedPresetKey === preset.key
                          ? "border-[#C95EBE] bg-[#FDF4FF]"
                          : "border-[#CCCCCC] border-[0.5px] bg-white hover:border-[#C95EBE]/70"
                      }`}
                    >
                      <div className="flex items-center gap-3 mb-2">
                        <div
                          className={`w-7 h-7 rounded-full flex items-center justify-center ${
                            selectedPresetKey === preset.key
                              ? "bg-[#C95EBE]/10"
                              : "bg-[#F4F4F5]"
                          }`}
                        >
                          {IndustryIcons[preset.key] || IndustryIcons.default}
                        </div>
                        <h4 className="text-[15px] font-medium text-[#18181B] font-outfit">
                          {preset.name}
                        </h4>
                      </div>

                      <div className="flex flex-wrap gap-2">
                        {preset.aspects.map((aspect, idx) => (
                          <div
                            key={idx}
                            className={`px-3 py-1 rounded-full text-[12px] font-normal font-outfit border ${
                              selectedPresetKey === preset.key
                                ? "bg-white border-[#C95EBE]/20 text-[#3F3F46]"
                                : "bg-[#F5F5F5] border-[#CCCCCC] text-[#3F3F46]"
                            }`}
                          >
                            {aspect.name} ({aspect.weightage}/10)
                          </div>
                        ))}
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </div>

        {/* Footer Buttons + Warning - Fixed at bottom */}
        <div className="px-6 pb-4 mt-2 flex items-center justify-between gap-3 flex-shrink-0 bg-white rounded-b-[16px]">
          {/* Left side: warning only for presets */}
          {tab === "presets" ? (
            <div className="flex items-center gap-2 text-[#71717A]">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
              <span className="text-[13px] font-outfit">
                Applying a preset will replace your current configuration.
              </span>
            </div>
          ) : (
            <div />
          )}

          {/* Right side: buttons (always right aligned) */}
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading || success}
              className="h-[42px] px-6 rounded-[8px] border border-[#CCCCCC] border-[0.5px] bg-white text-[14px] font-medium text-[#18181B] font-outfit hover:bg-gray-50 transition-colors disabled:opacity-50"
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={!canSubmit || loading || success}
              className={`h-[42px] px-6 rounded-[8px] text-[14px] font-medium font-outfit transition-all disabled:opacity-50 disabled:cursor-not-allowed text-white shadow-sm flex items-center gap-2 ${
                success ? "bg-[#2DAD4E]" : "bg-[#C95EBE] hover:bg-[#A3398D]"
              }`}
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  <span>{"Adding..."}</span>
                </>
              ) : success ? (
                <>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                  <span>{"Added"}</span>
                </>
              ) : (
                "Add Aspect"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddScoringAspectModal;
